import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {HttpService} from "../service/http-service";
import {API} from "../config/api-config";

declare var alertify:any;
@Component({
  templateUrl:"./memberTask.html"
})

export class MemberTask implements OnInit{

  constructor(
    private router:Router,
    private http:HttpService
  ){}

  private data:any=[];
  private imagePath:string='';
  ngOnInit(): void {
    this.getPath();

  }

  private getPath():void{
    this.http.getData(API.resourcePath)
      .then(res=>{
        this.imagePath=res.data;
        this.getData();
      })
  }

  private getData(){
    this.http.getData(API.sign_in_product).then(res=>{
      this.data=res.data;
      for (let i=0;i<this.data.length;i++){
        this.data[i].imageEn = this.imagePath+this.data[i].imageEn;
        this.data[i].imageTc = this.imagePath+this.data[i].imageTc;
      }
    });
  }

  private editProduct(id:number){
    this.router.navigate(['index/memberTask',id]);
  }
  //
  private deleteProduct(id:number):void{
    let _self = this;
    alertify.confirm("删除","確定要刪除嗎？",function () {
      _self.http.deleteData(API.sign_in_product+"/"+id).then(res=>{
        if(res.status.code==0){
          alertify.success(res.status.message);
          _self.getData();
        }else {
          alertify.error(res.status.message);
        }
      })
    },function () {

    })
  }


}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/task/memberTask.component.ts